export default {
    GB: {},
    RO: {}
}
